export var clientNames;
(function (clientNames) {
    clientNames["reactUi"] = "client-sdk-react-ui";
})(clientNames || (clientNames = {}));
export var baseUrls;
(function (baseUrls) {
    baseUrls["prod"] = "https://www.crossmint.io";
    baseUrls["dev"] = "http://localhost:3001";
})(baseUrls || (baseUrls = {}));
export var customHeaders;
(function (customHeaders) {
    customHeaders["clientVersion"] = "X-Client-Version";
    customHeaders["clientName"] = "X-Client-Name";
})(customHeaders || (customHeaders = {}));
export var mintingContractTypes;
(function (mintingContractTypes) {
    mintingContractTypes["CANDY_MACHINE"] = "candy-machine";
    mintingContractTypes["SOLANA_AUCTION"] = "solana-auction";
    mintingContractTypes["ERC_721"] = "erc-721";
})(mintingContractTypes || (mintingContractTypes = {}));
//# sourceMappingURL=types.js.map